module.exports = __webpack_public_path__ + "img/clients-damons.fbd8690b.png";